import type { PartialCrmMessages } from "./englishCrmMessages";

export const chineseCrmMessages: PartialCrmMessages = {
  resources: {
    companies: {
      name: "公司",
      forcedCaseName: "公司",
      fields: {
        name: "公司名称",
        website: "网站",
        linkedin_url: "LinkedIn 链接",
        phone_number: "电话号码",
        created_at: "创建时间",
        nb_contacts: "联系人数量",
        revenue: "营收",
        sector: "行业",
        size: "规模",
        tax_identifier: "税号",
        address: "地址",
        city: "城市",
        zipcode: "邮编",
        state_abbr: "省/州",
        country: "国家",
        description: "描述",
        context_links: "相关链接",
        sales_id: "客户经理",
      },
      empty: {
        description: "公司列表为空。",
        title: "暂无公司",
      },
      field_categories: {
        contact: "联系方式",
        additional_info: "附加信息",
        address: "地址",
        context: "上下文",
      },
      action: {
        create: "创建公司",
        edit: "编辑公司",
        new: "新建公司",
        show: "查看公司",
      },
      added_on: "添加于 %{date}",
      followed_by: "负责人：%{name}",
      followed_by_you: "由你负责",
      no_contacts: "暂无联系人",
      nb_contacts: "%{smart_count} 个联系人",
      nb_deals: "%{smart_count} 笔交易",
      sizes: {
        one_employee: "1 人",
        two_to_nine_employees: "2-9 人",
        ten_to_forty_nine_employees: "10-49 人",
        fifty_to_two_hundred_forty_nine_employees: "50-249 人",
        two_hundred_fifty_or_more_employees: "250 人以上",
      },
      autocomplete: {
        create_error: "创建公司时出错",
        create_item: "创建 %{item}",
        create_label: "输入以创建新公司",
      },
      filters: {
        only_mine: "仅显示我负责的公司",
      },
    },
    contacts: {
      name: "联系人",
      forcedCaseName: "联系人",
      field_categories: {
        background_info: "背景信息",
        identity: "身份",
        misc: "其他",
        personal_info: "个人信息",
        position: "职位",
        ecommerce: "电商信息",
      },
      fields: {
        first_name: "名",
        last_name: "姓",
        last_seen: "最近活跃",
        title: "职位",
        company_id: "公司",
        email_jsonb: "邮箱地址",
        email: "邮箱",
        phone_jsonb: "电话号码",
        phone_number: "电话",
        linkedin_url: "LinkedIn 链接",
        background: "背景信息（简介、认识经过等）",
        has_newsletter: "已订阅邮件",
        sales_id: "客户经理",
        vip_level: "VIP 等级",
        country_code: "国家",
        total_spent: "累计消费",
        stripe_customer_id: "Stripe 客户 ID",
      },
      action: {
        add: "添加联系人",
        add_first: "添加第一个联系人",
        create: "创建联系人",
        edit: "编辑联系人",
        export_vcard: "导出 vCard",
        new: "新建联系人",
        show: "查看联系人",
      },
      background: {
        last_activity_on: "最近活动于 %{date}",
        added_on: "添加于 %{date}",
        followed_by: "负责人：%{name}",
        followed_by_you: "由你负责",
        status_none: "无",
      },
      position_at: "%{title} 于",
      position_at_company: "%{title} 于 %{company}",
      empty: {
        description: "联系人列表为空。",
        title: "暂无联系人",
      },
      import: {
        title: "导入联系人",
        button: "导入 CSV",
        complete:
          "联系人导入完成。已导入 %{importCount} 个联系人，%{errorCount} 个错误",
        progress:
          "已导入 %{importCount} / %{rowCount} 个联系人，%{errorCount} 个错误。",
        error: "导入文件失败，请确保提供的是有效的 CSV 文件。",
        imported: "已导入",
        remaining_time: "预计剩余时间：",
        running: "正在导入，请勿关闭此页面。",
        sample_download: "下载 CSV 模板",
        sample_hint: "这是一个可作为模板使用的 CSV 示例文件",
        stop: "停止导入",
        csv_file: "CSV 文件",
        contacts_label: "联系人",
      },
      inputs: {
        genders: {
          male: "先生",
          female: "女士",
          nonbinary: "其他",
        },
        personal_info_types: {
          work: "工作",
          home: "个人",
          other: "其他",
        },
        vip_levels: {
          standard: "注册客户 Registered",
          silver:   "银牌 Silver",
          gold:     "金牌 Gold",
          platinum: "铂金 Platinum",
          diamond:  "钻石 Diamond",
        },
      },
      list: {
        error_loading: "加载联系人出错",
      },
      bulk_tag: {
        action: "打标签",
        back: "返回标签",
        create_description: "创建新标签并应用到选中的联系人。",
        description: "为选中的联系人选择已有标签或创建新标签。",
        empty: "暂无标签。创建一个标签来标记选中的联系人。",
        error: "为联系人添加标签失败",
        noop: "选中的联系人已有此标签",
        success: "已为 %{smart_count} 个联系人添加标签",
        title: "为联系人添加标签",
      },
      merge: {
        action: "与其他联系人合并",
        confirm: "确认合并",
        current_contact: "当前联系人（将被删除）",
        description: "将此联系人与另一个联系人合并。",
        error: "合并联系人失败",
        merging: "合并中...",
        no_additional_data: "无额外数据可合并",
        select_target: "请选择要合并的目标联系人",
        success: "联系人合并成功",
        target_contact: "目标联系人（将被保留）",
        title: "合并联系人",
        warning_description: "所有数据将转移到第二个联系人。此操作不可撤销。",
        warning_title: "警告：不可逆操作",
        what_will_be_merged: "将被合并的内容：",
      },
      filters: {
        before_last_month: "上月之前",
        before_this_month: "本月之前",
        before_this_week: "本周之前",
        managed_by_me: "由我负责",
        search: "搜索姓名、公司...",
        this_week: "本周",
        today: "今天",
        tags: "标签",
        tasks: "待办任务",
        vip_level: "VIP 等级",
      },
      hot: {
        empty_change_status:
          '前往联系人页面添加笔记，点击"显示选项"可更改联系人状态。',
        empty_hint: '状态为"热门"的联系人将显示在这里。',
        title: "热门联系人",
      },
    },
    deals: {
      name: "交易",
      fields: {
        name: "名称",
        description: "描述",
        company_id: "公司",
        contact_ids: "联系人",
        category: "类别",
        amount: "预算",
        expected_closing_date: "预计成交日期",
        stage: "阶段",
        stripe_session_id: "Stripe 会话 ID",
        currency: "币种",
      },
      action: {
        back_to_deal: "返回交易",
        create: "创建交易",
        new: "新建交易",
      },
      field_categories: {
        misc: "其他",
      },
      archived: {
        action: "归档",
        error: "错误：交易未归档",
        list_title: "已归档交易",
        success: "交易已归档",
        title: "已归档交易",
        view: "查看已归档交易",
      },
      inputs: {
        linked_to: "关联至",
      },
      unarchived: {
        action: "恢复到看板",
        error: "错误：交易未恢复",
        success: "交易已恢复",
      },
      updated: "交易已更新",
      empty: {
        before_create: "才能创建交易。",
        description: "交易列表为空。",
        title: "暂无交易",
      },
      invalid_date: "无效日期",
    },
    notes: {
      name: "笔记",
      forcedCaseName: "笔记",
      fields: {
        status: "状态",
        date: "日期",
        attachments: "附件",
        contact_id: "联系人",
        deal_id: "交易",
      },
      action: {
        add: "添加笔记",
        add_first: "添加第一条笔记",
        delete: "删除笔记",
        edit: "编辑笔记",
        update: "更新笔记",
        add_this: "添加此笔记",
        view_all: "查看全部 %{total} 条笔记",
      },
      sheet: {
        create: "创建笔记",
        create_for: "为 %{name} 创建笔记",
        edit: "编辑笔记",
        edit_for: "编辑 %{name} 的笔记",
      },
      deleted: "笔记已删除",
      empty: "暂无笔记",
      author_added: "%{name} 添加了一条笔记",
      you_added: "你添加了一条笔记",
      me: "我",
      list: {
        error_loading: "加载笔记出错",
      },
      note_for_contact: "%{name} 的笔记",
      stepper: {
        hint: "前往联系人页面添加笔记",
      },
      added: "笔记已添加",
      inputs: {
        add_note: "记录跟进内容、沟通摘要、客户反馈……（仅团队内部可见，不对客户展示）",
        options_hint: "（附加文件或修改详情）",
        show_options: "显示选项",
        note_usage_hint: "笔记用于记录销售跟进过程，仅团队内部可见",
      },
      validation: {
        note_or_attachment_required: "笔记或附件至少需要填写一项",
      },
    },
    sales: {
      name: "用户",
      fields: {
        first_name: "名",
        last_name: "姓",
        email: "邮箱",
        administrator: "管理员",
        disabled: "已禁用",
      },
      create: {
        error: "创建用户时出错。",
        success: "用户已创建。稍后将收到设置密码的邮件。",
        title: "创建新用户",
      },
      edit: {
        error: "操作出错，请重试。",
        record_not_found: "未找到记录",
        success: "用户更新成功",
        title: "编辑 %{name}",
      },
      action: {
        new: "新建用户",
      },
    },
    tasks: {
      name: "任务",
      forcedCaseName: "任务",
      fields: {
        text: "描述",
        due_date: "截止日期",
        type: "类型",
        contact_id: "联系人",
        due_short: "截止",
      },
      action: {
        add: "添加任务",
        create: "创建任务",
        edit: "编辑任务",
      },
      actions: {
        postpone_next_week: "推迟到下周",
        postpone_tomorrow: "推迟到明天",
        title: "任务操作",
      },
      added: "任务已添加",
      deleted: "任务已删除",
      dialog: {
        create: "创建任务",
        create_for: "为 %{name} 创建任务",
      },
      sheet: {
        edit: "编辑任务",
        edit_for: "编辑 %{name} 的任务",
      },
      empty: "暂无任务",
      empty_list_hint: "为联系人添加的任务将显示在这里。",
      filters: {
        later: "以后",
        overdue: "已逾期",
        this_week: "本周",
        today: "今天",
        tomorrow: "明天",
        with_pending: "有待办任务",
      },
      regarding_contact: "（关于：%{name}）",
      updated: "任务已更新",
    },
    tags: {
      name: "标签",
      action: {
        add: "添加标签",
        create: "创建新标签",
      },
      dialog: {
        color: "颜色",
        create_title: "创建新标签",
        edit_title: "编辑标签",
        name_label: "标签名称",
        name_placeholder: "输入标签名称",
      },
    },
  },
  crm: {
    action: {
      reset_password: "重置密码",
    },
    auth: {
      first_name: "名",
      last_name: "姓",
      confirm_password: "确认密码",
      confirmation_required: "请查看邮件中的确认链接以激活账户。",
      recovery_email_sent: "如果你是已注册用户，稍后将收到一封密码重置邮件。",
      sign_in_failed: "登录失败。",
      sign_in_google_workspace: "使用 Google Workspace 登录",
      signup: {
        create_account: "创建账户",
        create_first_user: "创建第一个用户账户以完成设置。",
        creating: "创建中...",
        initial_user_created: "初始用户创建成功",
      },
      welcome_title: "欢迎使用 Atomic CRM",
    },
    common: {
      activity: "动态",
      added: "已添加",
      details: "详情",
      last_activity_with_date: "最近活动 %{date}",
      load_more: "加载更多",
      misc: "其他",
      past: "过去",
      read_more: "查看更多",
      retry: "重试",
      show_less: "收起",
      copied: "已复制！",
      copy: "复制",
      loading: "加载中...",
      me: "我",
      task_count: "%{smart_count} 个任务",
    },
    activity: {
      added_company: "%{name} 添加了公司",
      you_added_company: "你添加了公司",
      added_contact: "%{name} 添加了",
      you_added_contact: "你添加了",
      added_note: "%{name} 添加了关于以下联系人的笔记",
      you_added_note: "你添加了关于以下联系人的笔记",
      added_note_about_deal: "%{name} 添加了关于交易的笔记",
      you_added_note_about_deal: "你添加了关于交易的笔记",
      added_deal: "%{name} 添加了交易",
      you_added_deal: "你添加了交易",
      at_company: "在",
      to: "到",
      load_more: "加载更多动态",
    },
    dashboard: {
      deals_chart: "预期交易收入",
      deals_pipeline: "交易管道",
      latest_activity: "最新动态",
      latest_activity_error: "加载最新动态出错",
      latest_notes: "我的最新笔记",
      latest_notes_added_ago: "%{timeAgo}前添加",
      stepper: {
        install: "安装 Atomic CRM",
        progress: "已完成 %{step}/3",
        whats_next: "下一步",
      },
      upcoming_tasks: "待办任务",
    },
    header: {
      import_data: "导入数据",
    },
    image_editor: {
      change: "更换",
      drop_hint: "拖放文件上传，或点击选择文件。",
      editable_content: "可编辑内容",
      title: "上传并裁剪图片",
      update_image: "更新图片",
    },
    import: {
      action: {
        download_error_report: "下载错误报告",
        import: "导入",
        import_another: "导入另一个文件",
      },
      error: {
        unable: "无法导入此文件。",
      },
      idle: {
        description_1: "你可以导入用户、公司、联系人、笔记和任务。",
        description_2: "数据必须是符合以下格式的 JSON 文件：",
      },
      status: {
        all_success: "所有记录已成功导入。",
        complete: "导入完成。",
        failed: "失败",
        imported: "已导入",
        in_progress: "正在导入，请勿离开此页面。",
        some_failed: "部分记录未能导入。",
        table_caption: "导入状态",
      },
      title: "导入数据",
    },
    settings: {
      companies: {
        sectors: "行业",
      },
      dark_mode_logo: "深色模式 Logo",
      deals: {
        categories: "类别",
        currency: "货币",
        pipeline_help: "选择哪些交易阶段应计入管道。",
        pipeline_statuses: "管道状态",
        stages: "阶段",
      },
      light_mode_logo: "浅色模式 Logo",
      notes: {
        statuses: "状态",
      },
      reset_defaults: "恢复默认",
      save_error: "保存配置失败",
      saved: "配置已保存",
      saving: "保存中...",
      tasks: {
        types: "类型",
      },
      preferences: "偏好设置",
      title: "设置",
      app_title: "应用标题",
      sections: {
        branding: "品牌",
        vip: "VIP 等级积分",
        roles: "角色权限",
      },
      validation: {
        duplicate: "重复的%{display_name}：%{items}",
        in_use: "无法删除仍被交易使用的%{display_name}：%{items}",
        validating: "验证中…",
        entities: {
          categories: "类别",
          stages: "阶段",
        },
      },
    },
    theme: {
      dark: "深色",
      label: "主题",
      light: "浅色",
      system: "跟随系统",
    },
    language: "语言",
    navigation: {
      label: "CRM 导航",
    },
    profile: {
      inbound: {
        description:
          "你可以将邮件发送到服务器的入站邮箱地址（例如添加到 %{field} 字段）。Atomic CRM 将处理邮件并为对应的联系人添加笔记。",
        title: "入站邮件",
      },
      mcp: {
        title: "MCP 服务器",
        description:
          "使用此 URL 通过 Model Context Protocol (MCP) 将你的 AI 助手连接到 CRM 数据。",
      },
      password: {
        change: "修改密码",
      },
      password_reset_sent: "密码重置邮件已发送到你的邮箱",
      record_not_found: "未找到记录",
      title: "个人资料",
      updated: "个人资料已更新",
      update_error: "操作出错，请重试",
    },
    validation: {
      invalid_url: "请输入有效的 URL",
      invalid_linkedin_url: "URL 必须来自 linkedin.com",
    },
  },
};
